import { createAction } from 'redux-actions';

export const signInAdminAsUser = createAction('SIGN_IN_ADMIN_AS_USER');

export const backToAdminFromUser = createAction('BACK_TO_ADMIN_FROM_USER');

export const setAdmin = createAction('SET_ADMIN');
